import { SortOrderings } from './types'

export const TABLE_HEADER_LABELS = [
	'Номер ошейника\nНомер бирки',
	'Группа',
	'Надой',
	'Последнее\nдоение',
	'Смена',
	'Доильный зал',
	'Действия',
]

export const COLUMN_WITH_SORTING: Record<string, SortOrderings> = {
	Группа: SortOrderings.BY_GROUP,
	Надой: SortOrderings.BY_LAST_MILK_AMOUNT,
	'Последнее\nдоение': SortOrderings.BY_LAST_MILKING_DT,
	Смена: SortOrderings.BY_PERIOD,
	'Доильный зал': SortOrderings.BY_MILKING_HALL,
}

export const PAGE_SIZE = 36
